import { Breakpoints, Container, ContainerGutter, ContainerPadding, CTA, Layout, styled, Text, TextAlignment, ThemeProvider, ThemeReference, TokenTextAppearance } from '@volkswagen-onehub/components-core';
import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { getHorariosCallMe } from 'src/bff/api/get-horarios-callme';
import { TriggerProps, useFaContent, useTransformToHtml } from 'src/feature-app';
import { CallMeForm } from 'src/forms';

interface contentStageProps {
	themeColor: ThemeReference;
}

const ContentStage = styled.div<contentStageProps>`
	overflow: hidden;
	display: flex;
	justify-content: center;
	align-items: center;
	background: ${(props) => (props.themeColor == 'inverted' ? 'radial-gradient(circle at bottom, #00437a 0%, #001e50 100%)' : '#ffffff')};
	padding: ${(props) => (props.themeColor === 'inverted' ? '44px 0' : '0')};

	& > div {
		width: ${(props) => (props.themeColor == 'inverted' ? '100%' : '92%')};
		margin: ${(props) => (props.themeColor == 'inverted' ? '0' : '0 4%')};
		border: ${(props) => (props.themeColor == 'inverted' ? 'none' : '2px solid #001e50')};
	}
`;

export function CallMeTrigger({ setSelectedJourney, setCTALabel }: TriggerProps) {
	const faContent = useFaContent();
	const dispatch = useDispatch();
	const [theme, setTheme] = useState<ThemeReference>('inverted');
	const [isOpenNow, setIsOpenNow] = useState<boolean>(false);

	const alternativeHeadline = ' <b>¿Quieres que te llamemos?</b>';
	const getTriggerHeadline = () => (faContent?.headline ? useTransformToHtml(faContent.headline) : useTransformToHtml(alternativeHeadline));

	const alternativeBodyCopy = 'Déjanos tus datos y nos pondremos en contacto contigo lo antes posible.';
	const getTriggerbodycopy = () => (faContent?.bodycopy ? useTransformToHtml(faContent.bodycopy) : useTransformToHtml(alternativeBodyCopy));

	const getCtaLabel = () => (faContent?.cta ? faContent.cta : 'Solicitar');

	const handleIsOpenNow = async () => {
		const horarios = await getHorariosCallMe();
		setIsOpenNow(horarios.isOpenNow);
	};

	useEffect(() => {
		if (faContent?.modo === 'Light') {
			setTheme('main');
		}
		handleIsOpenNow();
	}, []);

	return isOpenNow ? (
		<ThemeProvider theme={theme}>
			<ContentStage themeColor={theme}>
				<Layout
					appearance={{
						[Breakpoints.default]: [
							{ name: '.', columns: 2 },
							{ name: 'a', columns: 20 },
							{ name: '.', columns: 2 },
						],
						[Breakpoints.b960]: [
							{ name: '.', columns: 3 },
							{ name: 'a', columns: 18 },
							{ name: '.', columns: 3 },
						],
						[Breakpoints.b1280]: [
							{ name: '.', columns: 4 },
							{ name: 'a', columns: 16 },
							{ name: '.', columns: 4 },
						],
						[Breakpoints.b1600]: [
							{ name: '.', columns: 1 },
							{ name: 'a', columns: 22 },
							{ name: '.', columns: 1 },
						],
					}}
				>
					<Container wrap={'always'} gutter={ContainerGutter.dynamic0100} padding={{ top: ContainerPadding.dynamic0100, bottom: ContainerPadding.dynamic0100 }}>
						<Text textAlign={TextAlignment.center} appearance={TokenTextAppearance.headline300}>
							<div dangerouslySetInnerHTML={getTriggerHeadline()} />
						</Text>
						<Text textAlign={TextAlignment.center} appearance={TokenTextAppearance.copy200}>
							<div dangerouslySetInnerHTML={getTriggerbodycopy()} />
						</Text>
						<Container wrap={'always'} padding={{ top: ContainerPadding.dynamic0100 }}>
							<Text textAlign={TextAlignment.center}>
								<CTA
									tag="button"
									onClick={() => {
										dispatch({ type: 'RESET_STATE' });
										setCTALabel(getCtaLabel());
										setSelectedJourney(<CallMeForm />);
									}}
									stretchContent={{ [Breakpoints.default]: true, [Breakpoints.b560]: false }}
								>
									{getCtaLabel()}
								</CTA>
							</Text>
						</Container>
					</Container>
				</Layout>
			</ContentStage>
		</ThemeProvider>
	) : null;
}
